import { Component, OnInit, ViewChild } from '@angular/core';
import { GiftCardStepService } from '../../services/giftcard-step.service';
import { GiftCardStepEnum } from '../../models/giftcard-step.enum';
import { PartnerStateService } from '../../../partner/services/partner-state.service';

@Component({
  selector: 'app-giftcard-register',
  templateUrl: './giftcard-register.component.html',
  styleUrls: ['./giftcard-register.component.css']
})
export class GiftcardRegisterComponent implements OnInit {

  @ViewChild('partnerRegistrationForm', { static: true }) partnerRegistrationForm;

  constructor(
    private giftCardStepService: GiftCardStepService,
    private partnerStateService: PartnerStateService,
  ) {
  }

  ngOnInit(): void {
    this.partnerRegistrationForm.showPassword =
      this.giftCardStepService.step !== GiftCardStepEnum.RegisterAsGuest;
  }

  onBack(): void {
    this.giftCardStepService.update(
      GiftCardStepEnum.Login
    );
  }

  onRegister(): void {
    this.partnerStateService.createPartner(
      this.partnerRegistrationForm.partner,
      this.partnerRegistrationForm.password.password
    ).subscribe(
      result => {
        if (result) {
          this.giftCardStepService.update(
            GiftCardStepEnum.Payment
          );
        } else {
          this.partnerRegistrationForm.error = 'Registration failed. Please try again later';
        }
      },
      (error) => {
        this.partnerRegistrationForm.error = error.message;
      }
    );
  }
}
